// "2 items · 4 qty": distinct lines in the cart, and the total units on them.
export const cartQuantity = (cart) =>
  (cart || []).reduce((sum, item) => sum + (parseInt(item.qty, 10) || 1), 0);

export const cartSummaryText = (cart) => {
  const lines = (cart || []).length;
  return `${lines} item${lines !== 1 ? 's' : ''} · ${cartQuantity(cart)} qty`;
};
